import facebookLogo from "@Images/facebook.png";
import instagramLogo from "@Images/instagram.png";
import linkedinLogo from "@Images/linkedin.png";
import pinterestLogo from "@Images/pinterest.png";
import twitterLogo from "@Images/twitter.png";
import { LinkByLocales, SocialLinkByLocales } from "@Types/links";

export const cartLink = `/cart`;
export const cheerzLiveLink = `/products/cheerz-live-photo-booth`;
export const draftsLink = `/dashboard/drafts`;
export const giftLink = `/categories/gift-ideas`;
export const memoryBoxLink = `/product_subscriptions/memory-prints`;
export const ordersLink = `/orders`;
export const profileLink = `/dashboard/profile`;
export const referralsLink = `/dashboard#/referrals`;

export const confidentialityLink = "https://www.iubenda.com/privacy-policy/833692/full-legal";

export const commitmentsLinks: LinkByLocales = {
  en: "https://www.cheerz.com/en/categories/our-commitments",
  es: "https://www.cheerz.com/es/categories/nuestros-compromisos",
  fr: "https://royal.cheerz.com/inspire/nos-engagements",
  it: "https://www.cheerz.com/it/categories/responsabilita-sociale",
};

export const engagementsLinks: LinkByLocales = {
  en: "https://www.cheerz.com/en/categories/our-commitments",
  es: "https://www.cheerz.com/es/categories/nuestros-compromisos",
  fr: "https://royal.cheerz.com/inspire/nos-engagements",
  it: "https://www.cheerz.com/it/categories/responsabilita-sociale",
};

export const fscLinks: LinkByLocales = {
  en: "https://www.cheerz.com/fsc-certification",
  es: "https://www.cheerz.com/nuestra-certificacion-fsc",
  fr: "https://royal.cheerz.com/inspire/header-inspire/notre-certification-fsc/",
  it: "https://www.cheerz.com/certificazione-fsc",
};

export const socialLinks: SocialLinkByLocales[] = [
  {
    name: "Facebook",
    src: facebookLogo,
    url: {
      en: "http://www.facebook.com/cheerz.eu",
      es: "http://www.facebook.com/cheerz.es",
      fr: "http://www.facebook.com/cheerz.fr",
      it: "http://www.facebook.com/cheerz.it",
    },
  },
  { name: "Instagram", src: instagramLogo, url: { world: "https://instagram.com/cheerz/" } },
  {
    name: "Twitter",
    src: twitterLogo,
    url: {
      en: "https://twitter.com/cheerz_uk",
      es: "https://twitter.com/cheerz_es",
      world: "https://twitter.com/cheerzto",
    },
  },
  { name: "Pinterest", src: pinterestLogo, url: { world: "https://www.pinterest.com/cheerzto/" } },
  {
    name: "Linkedin",
    src: linkedinLogo,
    url: { world: "https://www.linkedin.com/company/cheerzofficial/" },
  },
];
